import {
  EXPORT_FILE,
  GET_EXPORT_FILE,
  SET_EXPORT_ID,
  SET_EXPORT_STATUS,
  EXPORTING_SHOW_EXPORT_MODAL,
  EXPORTING_HIDE_EXPORT_MODAL,
} from './constants';

export function exportFile(
  featureName,
  additional,
  outletId,
  asyncExport,
  mutexRelease
) {
  return {
    type: EXPORT_FILE,
    payload: { featureName, additional, outletId, asyncExport, mutexRelease },
  };
}

export function getExportFile(id) {
  return {
    type: GET_EXPORT_FILE,
    payload: { id },
  };
}

export function setExportStatus(status) {
  return {
    type: SET_EXPORT_STATUS,
    payload: { status },
  };
}

export function setExportId(id) {
  return {
    type: SET_EXPORT_ID,
    payload: { id },
  };
}

export function showExportingModal() {
  return { type: EXPORTING_SHOW_EXPORT_MODAL };
}

export function hideExportingModal() {
  return { type: EXPORTING_HIDE_EXPORT_MODAL };
}
